<template>
  <div>
    <b-table :dark="dark" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="captions" :current-page="currentPage" :per-page="perPage">
      <template slot="product_type" slot-scope="data">
        <b-badge pill :variant="getBadge(data.item.product_type)">{{data.item.product_type}}</b-badge>
      </template>
      <template  v-slot:cell(actions)="data" >
        <b-col cols="12" sm="12" md="12" lg="12">
          <a href="#" @click.prevent="deletePallet(data.item)" class="text-danger"><i class="fa fa-close fa-lg mt-1 " style="color:red"></i></a>
        </b-col>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
  </div>
</template>

<script>

import {bus} from "../../main";

export default {
  name: 'Detail',
  inheritAttrs: false,
  components: {
  },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => ['pallet_number', 'product_name', 'product_type_name', 'variety_name', 'origin_name', 'condition', 'container.name', 'quantity', 'net_kilograms', 'actions']
    },
    perPage: {
      type: Number,
      default: 15
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      infoModal: false,
      contentInfo: {}
    }
  },
  computed: {
    items: function() {
      const items =  this.tableData;
      return Array.isArray(items) ? items : items()
    },
    totalRows: function () { return this.getRowCount() },
    captions: function() { return this.fields }
  },
  methods: {
    editContent(data){
        bus.$emit('contentEditing', data);
      },
    showAlert(item) {
      alert(item)
    },
    getBadge (product_type) {
      return product_type === 'Fresco' ? 'success'
        : product_type === 'IQF' ? 'secondary'
          : product_type === 'i' ? 'warning'
            : product_type === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount: function () {
      return this.items.length
    },
    deletePallet: function (row) {
        this.$emit("deletePallet", row);
      }
  }
}
</script>
